import React from "react";
import ConfigETC from "../Class/ConfigETC.json";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

function Department_View({ list, max ,index , Onclick_SortingDepartment , Onclick_EditDepartment, Onclick_DeleteDepartment ,permissionEdit,permissionDel}) {

    return (
  
      <TableRow>
          <TableCell>
              <div>
                <b>{index}</b>
                <input type="hidden" id="hd_iddel" defaultValue={list.dept_id}>
                </input>
              </div>
              <div>
                <input type="hidden" id="hd_act">                
                </input>
              </div>
          </TableCell>
          <TableCell align="left"><div><b>{list.dept_name}</b></div></TableCell>
          <TableCell align="left"><div className="text-sm">{list.dept_desc}</div></TableCell>
          <TableCell align="center">
            <div>
              <span
                className={
                  list.dept_status === 1
                    ? ConfigETC.Status_active
                    : ConfigETC.Status_inactive
                  }
              >
                {list.dept_status_str}
              </span>
            </div>
          </TableCell>
          <TableCell align="center">
          {(permissionEdit === true) &&
            <div className="btn-group btn-group-sm">
                {(max === 1 && 
                  <div>
                  </div>
                ) ||
                (
                list.rowindex === 1 ? (
                  <div>
                      <a href="#!" title="down" onClick={() => Onclick_SortingDepartment("down",list.dept_id)} >
                          <i className="fas fa-arrow-alt-circle-down fa-lg"></i>
                      </a>
                  </div>
                ) : list.rowindex === max  ? (
                  <a href="#!" title="up" onClick={() => Onclick_SortingDepartment("up",list.dept_id)}  >
                    <i className="fas fa-arrow-alt-circle-up fa-lg"/>
                  </a>
                ) : (
                <>
                    <a href="#!" title="up" onClick={() => Onclick_SortingDepartment("up",list.dept_id)} >
                    <i className="fas fa-arrow-alt-circle-up fa-lg" />
                    </a>
                    <a href="#!" title="down" onClick={() => Onclick_SortingDepartment("down",list.dept_id)} >
                    <i className="fas fa-arrow-alt-circle-down fa-lg" />
                    </a>
                </>
                ))}
            </div>
           }
          </TableCell>
          <TableCell align="right">
          <div className="btn-group btn-group-sm">
            {(permissionEdit === true) &&
              <a
                href="#!"
                className="btn btn-primary btn-sm"
                onClick={(event) => Onclick_EditDepartment(event, list)}
              > <i className="fas fa-pencil-alt" />
              </a>
            }
            {(permissionDel === true) &&
              <a
                href="#!" className="btn btn-default btn-sm"
                onClick={() => Onclick_DeleteDepartment(list.dept_id)}
              > <i className="fas fa-trash" />
              </a>
            }
            </div>
          </TableCell>
      </TableRow> 
    );
  };
  
  export default Department_View